module.exports = __webpack_public_path__ + "img/usa_map.83627ec0.jpg";